import { useCallback, useEffect, useRef } from "react";

export const useClickOutside = (onClose: () => void) => {
  const ref = useRef(null);
  const escapeListener = useCallback((e: KeyboardEvent) => {
    if (e.key === "Escape") {
      onClose();
    }
    //eslint-disable-next-line
  }, []);
  const clickListener = useCallback(
    (e: MouseEvent) => {
      if (!(ref.current! as any)?.contains(e.target)) {
        onClose?.();
      }
    },
    //eslint-disable-next-line
    [ref.current]
  );
  useEffect(() => {
    document.addEventListener("click", clickListener);
    document.addEventListener("keyup", escapeListener);
    return () => {
      document.removeEventListener("click", clickListener);
      document.removeEventListener("keyup", escapeListener);
    };
    //eslint-disable-next-line
  }, []);
  return ref;
};
